/**
<copy-code success-text="Copied"><div class="common-copy-container">
    <div class="copy-child-container">
      <span class="discount-text">CODE:</span>
      <div class="discount-code">SAVE20</div>
      <button class="copy-btn"></button>
    </div>
  </div>
 
</copy-code>

 */

if (document.querySelector("copy-code")) {
  if (!customElements.get("copy-code")) {
    class CopyCode extends HTMLElement {
      constructor() {
        super();
        this.successText = this.getAttribute("success-text") || "Gekopieerd";
        this.render();
        this.bindEvents();
      }
      render() {
        const style = document.createElement("style");
        style.textContent = `
        .copy-success-text{
           display:none;
          }
        .copy-success-text {
          display: flex;
          gap: 12px;
          color: #000000;
          align-items: center;
          font-family: var(--misanslatin-demibold);
          font-size: clamp(14px,1.5vw,18px);
          position: fixed;
          top: 15%;
          top: 10%;
          left: 0;
          right: 0;
          width: fit-content;
          margin: auto;
          z-index: 5;
          box-shadow: 0px 0px 8px 0px #00000040;
          background: #fff;
          border-radius: 12px;
          padding: 12px 24px;
          z-index: 100000000;
       }
      .copy-success-text::before {
         content: '';
          background: url(https://cdn.shopify.com/s/files/1/0584/7508/6033/files/copy-code-arrow.png?v=1763030071) center / contain no-repeat;
          width: 24px;
          height: 24px;
          background-size: 10px 7px;
          background-color: #4CB414;
          border-radius: 50%;
        }
        .card-product-3  .card-product-3__image-container  .common-copy-container{
          justify-content: center;
        }
        
      `;
      const btn=document.createElement("button")
      btn.classList.add("copy-btn")
      
      document.head.appendChild(style);
      this.querySelector(".copy-child-container").appendChild(btn)
      this.parentElement.classList.add("card-copy-container")

      }
      // 绑定事件
      bindEvents() {
        const copyBtn = this.querySelector(".copy-btn");
        const copyContainer = this.querySelector(".common-copy-container");
        const discountCodeEl = this.querySelector(".discount-code");
        const text=this.successText
        copyBtn && copyBtn.removeEventListener("click", this.handleCopy);

        this.handleCopy = (event) => {
           event.preventDefault(); 
            event.stopPropagation();
          const content = discountCodeEl.textContent;

          const aux = document.createElement("input");
          aux.value = content;
          document.body.appendChild(aux);
          aux.select();
          document.execCommand("copy");
          document.body.removeChild(aux);

          // 显示激活状态（1秒后恢复）
          const successEl = document.createElement("div");
          successEl.classList.add("copy-success-text");
          successEl.innerText = text;
          document.body.appendChild(successEl);
          setTimeout(() => {
            document.body.removeChild(successEl);
          }, 1000);

          // 发送请求
          fetch(`/discount/${content}`)
            .then((response) => {
              if (response.ok) console.log("复制成功");
              else console.log("折扣码请求失败");
            })
            .catch((error) => console.error("请求错误:", error));
        };

        copyBtn.addEventListener("click", this.handleCopy);
      }
    }

    customElements.define("copy-code", CopyCode);
  }
}
